module.exports = __webpack_public_path__ + "media/images/logo-002b67322edf8dda85d0073c5079c5f2.jpg";